// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import axios from 'axios';
import { ACCESS_TYPE, API_BASE_URL } from '@/constants';
import { GetUserInfo } from '@/api/userCenter';
// 引入lke统一渲染插件
import lkeComponent from 'lke-component';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(lkeComponent);
const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
  let iconpath = '/iconfont.js';
  vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
  console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

// 路由守衛已移至 src/router/index.js 中統一管理
// 避免多個路由守衛導致衝突

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

window.__EMBED_STATE__ = new Vue({
  data: {
    source: ''
  }
});

let hasAppliedWallDefaultRoute = false;

function normalizeEmbedSource (source) {
  return source && typeof source === 'string' ? source.trim().toLowerCase() : '';
}

function applyDefaultRouteForEmbedSource (source) {
  if (source !== 'wall' || hasAppliedWallDefaultRoute) return;

  const currentPath = router.currentRoute && router.currentRoute.path;
  if (currentPath === '/' || currentPath === '/compliance-assistant') {
    hasAppliedWallDefaultRoute = true;
    router.replace('/curtain-assistant').catch(() => {});
  }
}

function setEmbedSource (source) {
  const normalizedSource = normalizeEmbedSource(source);
  if (!normalizedSource) return;

  window.__EMBED_SOURCE__ = normalizedSource;
  window.__EMBED_STATE__.source = normalizedSource;
  applyDefaultRouteForEmbedSource(normalizedSource);
}

Object.defineProperty(window, 'userType', {
  writable: false,
  enumerable: false,
  configurable: false,
  value: 2
});

window.$initType = 'ComplianceAssistant';

// 導入 EventHub（總是需要的）
import '@/manage/utils/EventHub';

// 标记：是否在 iframe 内打开（供 UI 隐藏“登录/退出”等入口）
try {
  const isIframe = window.self !== window.top;
  window.__EMBEDDED__ = !!isIframe;
} catch (e) {
  // 某些场景会因跨域访问 top 抛错，此时按 iframe 处理
  window.__EMBEDDED__ = true;
}

function getDemoTokenUrl () {
  return '/api/getDemoToken';
}

function safeSetWebimToken (demoToken) {
  const tokenValue = [{
    type: 5,
    token: demoToken,
    access: 'ws'
  }];

  const existingDescriptor = Object.getOwnPropertyDescriptor(window, 'webimToken');
  try {
    if (existingDescriptor) {
      if (existingDescriptor.configurable) {
        delete window.webimToken;
        Object.defineProperty(window, 'webimToken', {
          writable: false,
          enumerable: false,
          configurable: true,
          value: tokenValue
        });
      } else if (existingDescriptor.writable) {
        window.webimToken = tokenValue;
      } else {
        // 不可写不可配：尽量不打断流程
        // eslint-disable-next-line no-console
        console.warn('【iframe-token】window.webimToken 不可写，跳过覆盖');
      }
    } else {
      Object.defineProperty(window, 'webimToken', {
        writable: false,
        enumerable: false,
        configurable: true,
        value: tokenValue
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('【iframe-token】设置 window.webimToken 失败:', e);
  }
}

function triggerSocketReconnect () {
  try {
    // 优先通过 EventHub 触发 Socket.js 里监听的重连逻辑
    if (Vue.prototype && Vue.prototype.$eventHub && typeof Vue.prototype.$eventHub.$emit === 'function') {
      Vue.prototype.$eventHub.$emit('socket_reconnect');
      // eslint-disable-next-line no-console
      console.log('【iframe-token】已触发 socket_reconnect 事件');
      return;
    }
    // 兜底：若直接暴露了 $socket.reconnect
    if (Vue.prototype && Vue.prototype.$socket && typeof Vue.prototype.$socket.reconnect === 'function') {
      Vue.prototype.$socket.reconnect();
      // eslint-disable-next-line no-console
      console.log('【iframe-token】已调用 $socket.reconnect()');
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('【iframe-token】触发 socket 重连失败:', e);
  }
}

async function applyAccessTokenAndInit (accessToken) {
  if (!accessToken || typeof accessToken !== 'string') return false;

  // 写入登录态 token（request 拦截器会自动带上）
  localStorage.setItem('beesfpd_token', accessToken);

  // 1) 验证 token / 拉取用户信息
  const userInfo = await GetUserInfo().catch(() => null);
  if (!userInfo || userInfo.code !== 200 || !userInfo.data) {
    return false;
  }

  localStorage.setItem('beesfpd_user_info', JSON.stringify(userInfo.data));
  const userId = userInfo.data.userId;
  if (userId) {
    localStorage.setItem('VisitorBizId', userId);
  }

  // 2) 获取 demoToken，初始化 ws/webimToken（用于 socket）
  if (userId) {
    const demoTokenUrl = getDemoTokenUrl();
    const res = await axios.get(demoTokenUrl, { params: { VisitorBizId: userId } }).catch(() => null);
    const demoToken = res && res.data && res.data.apiResponse && res.data.apiResponse.Token;
    if (demoToken) {
      safeSetWebimToken(demoToken);
      // 动态注入 mixin（与登录页保持一致）
      const mixin = await import('@/manage/index');
      Vue.mixin(mixin);
      triggerSocketReconnect();
    }
  }

  return true;
}

async function applyIframeAuthAndInit ({ accessToken, visitorBizId, wsToken }) {
  // 1) 先落地 token（如果有）
  if (accessToken && typeof accessToken === 'string') {
    localStorage.setItem('beesfpd_token', accessToken);
  }

  // 2) 先落地 VisitorBizId（父页面已知的话直接传，避免再打一遍 GetUserInfo）
  const vid = visitorBizId != null ? String(visitorBizId) : '';
  if (vid) {
    localStorage.setItem('VisitorBizId', vid);
  }

  // 3) 如果父页面直接给了 wsToken，就直接初始化 webimToken（跳过 /api/getDemoToken）
  if (wsToken && typeof wsToken === 'string') {
    safeSetWebimToken(wsToken);
    const mixin = await import('@/manage/index');
    Vue.mixin(mixin);
    triggerSocketReconnect();
    return true;
  }

  // 4) 若没拿到 VisitorBizId，但有 accessToken，则尝试用 GetUserInfo 验证并补齐 VisitorBizId
  if (!vid && accessToken && typeof accessToken === 'string') {
    const ok = await applyAccessTokenAndInit(accessToken);
    return ok;
  }

  // 5) 若已有 VisitorBizId（不论来源），就尝试拉取 demoToken 初始化 ws
  const finalVid = localStorage.getItem('VisitorBizId') || '';
  if (finalVid) {
    const demoTokenUrl = getDemoTokenUrl();
    const res = await axios.get(demoTokenUrl, { params: { VisitorBizId: finalVid } }).catch(() => null);
    const demoToken = res && res.data && res.data.apiResponse && res.data.apiResponse.Token;
    if (demoToken) {
      safeSetWebimToken(demoToken);
      const mixin = await import('@/manage/index');
      Vue.mixin(mixin);
      triggerSocketReconnect();
      return true;
    }
  }

  return !!finalVid;
}

function extractAuthFromLocation () {
  const result = { token: '', VisitorBizId: '', source: '' };
  try {
    const url = new URL(window.location.href);
    const q = url.searchParams;
    result.token =
      q.get('access_token') ||
      q.get('accessToken') ||
      q.get('token') ||
      q.get('beesfpd_token') ||
      '';
    result.VisitorBizId =
      q.get('VisitorBizId') ||
      q.get('visitorBizId') ||
      q.get('userId') ||
      q.get('userid') ||
      '';
    result.source =
      q.get('source') ||
      q.get('embedSource') ||
      q.get('embed_source') ||
      '';
    if (!result.source && /fireFightingWebWall/i.test(url.pathname)) {
      result.source = 'wall';
    }
  } catch (e) {
    // ignore
  }

  // 兼容 hash 路由：#/path?token=xxx&VisitorBizId=yyy
  try {
    const hash = window.location.hash || '';
    const hashQueryString = hash.includes('?') ? hash.split('?')[1] : '';
    if (hashQueryString) {
      const hq = new URLSearchParams(hashQueryString);
      if (!result.token) {
        result.token =
          hq.get('access_token') ||
          hq.get('accessToken') ||
          hq.get('token') ||
          hq.get('beesfpd_token') ||
          '';
      }
      if (!result.VisitorBizId) {
        result.VisitorBizId =
          hq.get('VisitorBizId') ||
          hq.get('visitorBizId') ||
          hq.get('userId') ||
          hq.get('userid') ||
          '';
      }
      if (!result.source) {
        result.source =
          hq.get('source') ||
          hq.get('embedSource') ||
          hq.get('embed_source') ||
          '';
      }
    }
  } catch (e) {
    // ignore
  }

  return result;
}

function setupIframeTokenBridge () {
  // 1) 支持 query 直传（例如 ?token=xxx）
  const authFromUrl = extractAuthFromLocation();
  if (authFromUrl && authFromUrl.source) {
    setEmbedSource(authFromUrl.source);
  }
  if (authFromUrl && (authFromUrl.token || authFromUrl.VisitorBizId)) {
    applyIframeAuthAndInit({
      accessToken: authFromUrl.token,
      visitorBizId: authFromUrl.VisitorBizId,
      wsToken: ''
    }).then((ok) => {
      if (ok && router.currentRoute && router.currentRoute.path === '/login') {
        router.replace('/').catch(() => {});
      }
    });
  }

  // 1.5) 如果是 iframe 打开，主动通知父页面“已就绪”，并请求一次授权数据
  if (window.__EMBEDDED__) {
    try {
      const msgReady = { type: 'gbcad:ready', source: 'gb-cad-compliance-assistant' };
      const msgRequest = { type: 'gbcad:request_auth', source: 'gb-cad-compliance-assistant' };
      window.parent && window.parent.postMessage(msgReady, '*');
      window.parent && window.parent.postMessage(msgRequest, '*');
      // eslint-disable-next-line no-console
      console.log('【iframe-token】已向父页面发送 ready/request_auth');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('【iframe-token】向父页面 postMessage 失败:', e);
    }
  }

  // 2) 支持 postMessage 传 token（推荐）
  window.addEventListener('message', (evt) => {
    const data = evt && evt.data;
    if (!data) return;

    // 兼容多种父页消息格式：
    // 1) 直接传 { token, VisitorBizId }
    // 2) 传 { accessToken, visitorBizId, wsToken }
    // 3) 传 { type: 'gbcad:auth', payload: { token, VisitorBizId, wsToken } }
    const payload = (data && data.payload) ? data.payload : data;

    const token =
      (typeof payload === 'string' && payload) ||
      (payload && (payload.accessToken || payload.access_token || payload.token || payload.beesfpd_token));
    const visitorBizId = payload && (payload.VisitorBizId || payload.visitorBizId || payload.userId || payload.userid);
    const wsToken = payload && (payload.wsToken || payload.webimToken || payload.demoToken);
    const source = payload && payload.source ? payload.source : (data && data.source);

    setEmbedSource(source);

    if ((!token || typeof token !== 'string') && !visitorBizId && !wsToken) return;

    // eslint-disable-next-line no-console
    console.log('【iframe-token】收到 postMessage 授权数据:', {
      hasToken: !!token,
      hasVisitorBizId: !!visitorBizId,
      hasWsToken: !!wsToken,
      source: window.__EMBED_SOURCE__ || ''
    });

    applyIframeAuthAndInit({ accessToken: token, visitorBizId, wsToken }).then((ok) => {
      // eslint-disable-next-line no-console
      console.log('【iframe-token】初始化结果:', ok, {
        VisitorBizId: localStorage.getItem('VisitorBizId'),
        hasBeesToken: !!localStorage.getItem('beesfpd_token'),
        hasWebimToken: !!(window.webimToken && Array.isArray(window.webimToken) && window.webimToken[0] && window.webimToken[0].token)
      });
      if (!ok) return;
      // 如果当前在登录页（或刚被引导去登录），直接回到首页/原页面
      const redirectRaw = router.currentRoute && router.currentRoute.query && router.currentRoute.query.redirect;
      const redirect = typeof redirectRaw === 'string' && redirectRaw.startsWith('/') ? redirectRaw : '/';
      if (router.currentRoute && router.currentRoute.path === '/login') {
        router.replace(redirect).catch(() => {});
      }
    });
  });
}

// 初始化應用
(async () => {
  setupIframeTokenBridge();
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    render (h) {
      return h(App);
    }
  }).$mount('#app');
})();



// WEBPACK FOOTER //
// ./src/main.js